<div>
  <div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
    <h3>¿Conoces o has participado en p1 en tu lugar de trabajo? . - p1d</h3>
    <!-- <mat-form-field>
    <input matInput placeholder="Pregunta nps" formControlName="firstCtrl" required>
  </mat-form-field> -->
  <mat-radio-group aria-label="Select an option"  class="example-radio-group">
    <mat-radio-button value="1">Si</mat-radio-button>
    <mat-radio-button value="2">No</mat-radio-button>

  </mat-radio-group>
  </div>
  <div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
    <h3>¿Conoces o has participado en p2 en tu lugar de trabajo? . - p2d</h3>
    <!-- <mat-form-field>
    <input matInput placeholder="Pregunta nps" formControlName="firstCtrl" required>
  </mat-form-field> -->
  <mat-radio-group aria-label="Select an option"  class="example-radio-group">
    <mat-radio-button value="1">Si</mat-radio-button>
    <mat-radio-button value="2">No</mat-radio-button>
  </mat-radio-group>
  </div>
  <div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
    <h3>¿Conoces o has participado en p3 en tu lugar de trabajo? . - p3d</h3>
    <!-- <mat-form-field>
    <input matInput placeholder="Pregunta nps" formControlName="firstCtrl" required>
  </mat-form-field> -->
  <mat-radio-group aria-label="Select an option"   class="example-radio-group">
    <mat-radio-button value="1">Si</mat-radio-button>
    <mat-radio-button value="2">No</mat-radio-button>
  </mat-radio-group>
  </div>

</div>
